import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const CheckoutSuccessPage = lazy(() => import('../pages/checkout-success/page'));
const DownloadsPage = lazy(() => import('../pages/downloads/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/product-detail/:id',
    element: <ProductDetailPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/checkout',
    element: <CheckoutPage />
  },
  {
    path: '/checkout-success',
    element: <CheckoutSuccessPage />
  },
  {
    path: '/downloads',
    element: <DownloadsPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
